<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oV3YJF/tc-custom/9781473818156.jpg?1726444214848" alt="This image is the cover for the book Shot at Dawn"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shot at Dawn
      </h1>
      <p class="bookDescription body article font2">
        <p><b>This groundbreaking work of military history reveals the unsettling truth about British Army executions during WWI.</b><br/><br/> The issue of military executions during the war has always been controversial, and embargoes have long kept historians from researching it. Julian Putkowski has spent decades uncovering the stories of mutinies and soldiers accused of desertion, and of the executions that followed.<br/><br/> In <i>Shot at Dawn</i>, Putkowski and co-author Julian Sykes shed light on a practice that for too long has been shrouded in secrecy. They show that trials were grossly unfair and incompetent. Many of the condemned men had been soldiers of exemplary behavior, courage, and leadership who cracked under the dreadful strain of trench warfare. This acclaimed book is the authority on this shameful legacy. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julian Putkowski, Julian Sykes
      </h2>
      
      <p class="authorDescription body article">Mark Dunning combines his successful career as a lawyer specialising in legal redress with a twenty year long research interest in British Army capital courts martial cases. In 2010 he was awarded an MA in Modern British History by the University of York. Julian Putkowski is a university lecturer residing in Hackney and a member of the Scientific Committee of the In Flanders Fields Museum, Ieper. Since 1978 his research about the British Army during the Great War has featured in many radio and TV programmes, including The Monocled Mutineer (BBC); Going Home (Opix), and Mutiny (Sweet Patootee). Julian writes authoritatively about mutinies and military misdeeds, and with Julian Sykes he co-authored Shot at Dawn and supported the campaign to secure posthumous pardons for the executed men.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Leo Cooper
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f9517b1e